export function waitForElement(selector: string, callback: (element: HTMLElement) => void): void {
  let htmlElement = document.querySelector<HTMLElement>(selector);

  if (htmlElement) {
    callback(htmlElement);
  } else {
    requestAnimationFrame(() => waitForElement(selector, callback));
  }
}
